import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  title: string;
  subtitle?: string | null;
  value: number | null;
  info?: string | null;
  color?: string;
  loading?: boolean;
}


import { modals } from '@modals';

import DisplayTextNumber from '@components/Display/DisplayTextNumber.vue';
import Icon from '@components/Icon.vue';

import { faInfoCircle } from '@icons/duotone/faInfoCircle';

declare module 'vue/types/vue' {
  export interface Vue {
    CardStat: ComponentWithProps<Props>;
  }
}

const __default__ = { name: 'CardStat' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    title: null,
    subtitle: { default: null },
    value: null,
    info: { default: null },
    color: { default: 'inherit' },
    loading: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { title: string, subtitle: string | null, value: number | null, info: string | null, color: string, loading: boolean };

/**
 * `CardStat` component properties.
 */


function viewInfo() {
  const title = props.title.toUpperCase() + ' STATISTICS';
  const text = props.info ?? '';

  void modals.util.generalInfo({ title, text });
}

return { __sfc: true,props, viewInfo, DisplayTextNumber, Icon, faInfoCircle }
}

})